import React, { useCallback, useRef } from 'react';
import { nanoid } from 'nanoid';
import { Container, Label, RadioInput, StuntDouble } from "./Radio.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A Radio Component. It renders a radio input with a label.
 * It works exactly like a normal radio input, but it has a custom style.
 *
 * @param disabled If the radio input is disabled
 * @param label The label of the radio input
 * @param name The name of the radio input
 * @param size The size of the radio input
 * @param value The value of the radio input
 * @param onChange The onChange event of the radio input
 * @param onClick The onClick event of the radio input
 */
const Radio = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    id,
    name,
    value,
    label,
    disabled,
    size = 'md',
    onChange,
    onClick,
    ...rest
  } = props;
  const elemId = useRef(nanoid(10));
  const handleActivateRadio = useCallback(() => {
    const input = document.getElementById(elemId.current);
    if (!disabled && input) {
      input.checked = true;
      onChange?.({
        target: input
      });
    }
  }, [disabled]);
  return /*#__PURE__*/_jsxs(Container, {
    disabled: disabled,
    children: [/*#__PURE__*/_jsx(RadioInput, {
      ...rest,
      disabled: disabled,
      id: elemId.current,
      name: name,
      onChange: e => onChange?.(e),
      onClick: e => onClick?.(e),
      ref: ref,
      inputSize: size,
      type: "radio",
      value: value
    }), /*#__PURE__*/_jsx(StuntDouble, {
      onClick: e => {
        handleActivateRadio();
        onClick?.(e);
      },
      disabled: disabled,
      inputSize: size,
      type: "button"
    }), label && /*#__PURE__*/_jsx(Label, {
      htmlFor: elemId.current,
      inputSize: size,
      disabled: disabled,
      children: label
    })]
  });
});
Radio.displayName = 'Radio';
export { Radio };